import { makeStyles, tokens, Switch, Text } from '@coreai/fluentui-react';
import { ArrowSyncFilled } from '@fluentui/react-icons';

type AutoRefreshToggleProps = {
  enabled: boolean;
  onToggle: () => void;
};

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  icon: {
    color: tokens.colorNeutralForeground3,
  },
  iconActive: {
    color: tokens.colorBrandForeground1,
  },
  label: {
    flex: 1,
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase200,
  },
});

export const AutoRefreshToggle = ({ enabled, onToggle }: AutoRefreshToggleProps) => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <ArrowSyncFilled className={enabled ? styles.iconActive : styles.icon} />
      <Text className={styles.label}>Auto-refresh</Text>
      <Switch
        checked={enabled}
        onChange={onToggle}
        aria-label="Toggle auto-refresh"
      />
    </div>
  );
};
